import { useTranslation } from 'react-i18next';
import Container from '@/components/ui/Container';
import SectionHeading from '@/components/ui/SectionHeading';
import TestimonialCard from './TestimonialCard';

const testimonialKeys = ['1', '2', '3'] as const;

export default function Testimonials() {
  const { t } = useTranslation();

  const testimonials = testimonialKeys.map((key) => ({
    quote: t(`testimonials.items.${key}.quote`),
    name: t(`testimonials.items.${key}.name`),
    title: t(`testimonials.items.${key}.title`),
  }));

  return (
    <section className="py-20 md:py-28 bg-gradient-to-r from-mk-pink-600 to-mk-pink-500">
      <Container>
        <SectionHeading
          title={t('testimonials.title')}
          subtitle={t('testimonials.subtitle')}
          light
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={testimonialKeys[index]} {...testimonial} delay={index * 0.15} />
          ))}
        </div>
      </Container>
    </section>
  );
}
